<div class="row clearfix">
  <div class="col-md-12" *ngIf="form">
    <form (ngSubmit)="saveConfig()" [formGroup]="form">

      <div class="card">
        <div class="header">
          <h2>WhatsApp Oficial - Meta</h2>
        </div>
        <div class="body">
          <div class="row">
            <div class="col-md-12">
              <p>
                Conecte a conta comercial e o número do WhatsApp pelo Embedded Signup da Meta.
              </p>

              <button
                mat-flat-button
                type="button"
                color="primary"
                class="button-row"
                (click)="conectarWhatsAppMeta()"
                [disabled]="!metaSdkCarregado || metaConectando">
                <span>
                  {{ metaConectando ? 'Aguardando Meta...' : 'Conectar WhatsApp Oficial' }}
                </span>
              </button>

              <button
                *ngIf="tenant && !tenant.registradoWpp"
                mat-flat-button
                type="button"
                color="primary"
                class="button-row"
                style="margin-left: 10px;"
                (click)="registrarTelefoneMeta()"
                [disabled]="!tenantTemConfiguracaoMeta() || metaRegistrandoTelefone">
                <span>
                  {{ metaRegistrandoTelefone ? 'Registrando...' : 'Registrar Número' }}
                </span>
              </button>

              <button
                *ngIf="tenant && tenant.registradoWpp"
                mat-flat-button
                type="button"
                color="primary"
                class="button-row"
                style="margin-left: 10px;"
                (click)="subscribeMetaApp()"
                [disabled]="metaInscrevendoApp">
                <span>
                  {{ metaInscrevendoApp ? 'Inscrevendo...' : 'Inscrever App' }}
                </span>
              </button>

              <span style="margin-left: 15px;">
                {{ metaStatus }}
              </span>
            </div>
          </div>

          <div
            class="row"
            style="margin-top: 15px;"
            *ngIf="tenant || metaWabaId || metaPhoneNumberId || metaDataConexaoMetaApi">
            <div class="col-md-3">
              <mat-form-field style="width: 100%;">
                <mat-label>WABA ID</mat-label>
                <input matInput [value]="metaWabaId" type="text" readonly />
              </mat-form-field>
            </div>

            <div class="col-md-3">
              <mat-form-field style="width: 100%;">
                <mat-label>Phone Number ID</mat-label>
                <input matInput [value]="metaPhoneNumberId" type="text" readonly />
              </mat-form-field>
            </div>

            <div class="col-md-3">
              <mat-form-field style="width: 100%;">
                <mat-label>Data Conexão Meta API</mat-label>
                <input matInput [value]="metaDataConexaoMetaApi | date :'dd/MM/yyyy HH:mm'" type="text" readonly />
              </mat-form-field>
            </div>

            <div class="col-md-3">
              <mat-form-field style="width: 100%;">
                <mat-label>Número Registrado</mat-label>
                <mat-select [value]="tenant && tenant.registradoWpp" disabled>
                  <mat-option *ngFor="let item of typesService.boolTypes" [value]="item.value">
                    {{item.text}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <hr>
          <div class="row">
            <div class="col-md-12">
              <h4>Funções de teste</h4>
              <button
                mat-flat-button
                type="button"
                color="primary"
                class="button-row"
                (click)="consultarMetaSubscribedApps()"
                [disabled]="!tenantTemConfiguracaoMeta() || metaConsultandoApps">
                <span>
                  {{ metaConsultandoApps ? 'Consultando...' : 'Testar apps inscritos' }}
                </span>
              </button>

              <!-- <button mat-flat-button type="button" color="warn" class="button-row" style="margin-left: 10px;"
                (click)="removerMetaSubscribedApp()" [disabled]="!tenantTemConfiguracaoMeta() || metaRemovendoApp">
                <span>
                  {{ metaRemovendoApp ? 'Removendo...' : 'Remover inscrição do app' }}
                </span>
              </button>

              <button
                mat-flat-button
                type="button"
                color="warn"
                class="button-row"
                style="margin-left: 10px;"
                (click)="desregistrarMetaPhoneNumber()"
                [disabled]="!tenantTemConfiguracaoMeta() || metaDesregistrandoTelefone">
                <span>
                  {{ metaDesregistrandoTelefone ? 'Desregistrando...' : 'Desregistrar número da Meta' }}
                </span>
              </button> -->
            </div>
          </div>

          <div class="row" style="margin-top: 15px;" *ngIf="metaSubscribedAppsConsultado">
            <div class="col-md-12">
              <div *ngIf="!metaSubscribedApps.length" class="alert alert-info" role="alert">
                Nenhum app inscrito retornado pela Meta.
              </div>

              <div *ngIf="metaSubscribedApps.length" class="table-responsive">
                <table class="table table-bordered table-striped table-hover">
                  <thead>
                    <tr>
                      <th class="text-center" width="220">App ID</th>
                      <th class="text-center">Nome</th>
                      <th class="text-center">Link</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let app of metaSubscribedApps">
                      <td>{{app.id}}</td>
                      <td>{{app.name}}</td>
                      <td>
                        <a *ngIf="app.link" [href]="app.link" target="_blank" rel="noopener">
                          {{app.link}}
                        </a>
                        <span *ngIf="!app.link">Não informado</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <hr>




          <div class="row">
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Erros de Cliente => Transf.Atendente</mat-label>
                <input matInput formControlName="qtdErros" type="number" />
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Mensagem Cancelamento pelo Cliente</mat-label>
                <textarea matInput formControlName="msgCancCliente" rows="3"></textarea>
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Mensagem Transferência para Atendente</mat-label>
                <textarea matInput formControlName="msgTransfAtendente" rows="3"></textarea>
              </mat-form-field>
            </div>
          </div>
          <hr>
          <div class="row text-right">
            <button mat-flat-button [disabled]="!form.valid || isBusy" type="submit" (click)="saveConfig()"
              color="primary" class="button-row">
              <span> Salvar</span>
            </button>
          </div>
        </div>
      </div>

    </form>
  </div>

  <div class="col-md-12">
    <div class="card">
      <div class="header">
        <h2>ChatBot - Fluxo Etapas de Atendimento</h2>
      </div>
      <div class="body table-responsive">
        <!--query end-->
        <table datatable [dtOptions]="dtOptions" class="table table-bordered table-striped table-hover"
          style="width: 100%;">
          <thead>
            <tr>
              <th class="text-center" width="70">Tipo Fluxo</th>
              <th class="text-center" width="100">Máscara</th>
              <th class="text-center">Nome</th>
              <th class="text-center" width="70">Tipo</th>
              <th class="text-center" width="200">Tipo Atendimento</th>
              <th class="text-center" width="200">Tipo Campo</th>
              <th class="text-center" width="100">Próxima Etapa</th>
              <th class="text-center" width="150"></th>
            </tr>
          </thead>
          <tbody *ngIf="models?.length != 0">
            <tr *ngFor="let model of models">
              <td>
                <span class="label" [ngClass]="typesService.getBotFluxoTypeColor(model.tipoFluxo)">
                  {{typesService.getBotFluxoTypeNome(model.tipoFluxo)}}
                </span>
              </td>
              <td>
                {{model.mascara}}
              </td>
              <td>
                {{model.nome}}
              </td>
              <td>
                <span class="label" [ngClass]="typesService.getBotNodoTypeColor(model.tipo)">
                  {{typesService.getBotNodoTypeNome(model.tipo)}}
                </span>
              </td>
              <td>
                <span class="label" [ngClass]="typesService.getBotAtendimentoTypeColor(model.tipoAtendimento)">
                  {{typesService.getBotAtendimentoTypeNome(model.tipoAtendimento)}}
                </span>
              </td>
              <td>
                {{typesService.getWhatsChatMsgCampoTypeNome(model.tipoCampo)}}
              </td>
              <td>
                {{model.proxNodo || "Não possuí"}}
              </td>
              <td class="text-center">
                <button [disabled]="!isAllowed('Update')" mat-icon-button type="button" (click)="edit(model)"
                  matTooltip="Editar">
                  <mat-icon>edit</mat-icon>
                </button>
                <button [disabled]="!isAllowed('Read')" mat-icon-button type="button" (click)="detail(model)"
                  matTooltip="Detalhes">
                  <mat-icon>description</mat-icon>
                </button>
                <button [disabled]="!isAllowed('Delete')" mat-icon-button type="button" (click)="delete(model.id)"
                  matTooltip="Excluir">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="fixed-action-btn">
        <button [disabled]="!isAllowed('Create')" mat-fab color="primary" (click)="create()" matTooltip="Adicionar (F9)"
          matTooltipPosition="above">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
<app-chatbot-nodo-modal #modal (modalSave)="onResponse($event)"></app-chatbot-nodo-modal>
